import { render, staticRenderFns } from "./attendance-code-form.vue?vue&type=template&id=6013ae70&scoped=true"
import script from "./attendance-code-form.vue?vue&type=script&lang=js"
export * from "./attendance-code-form.vue?vue&type=script&lang=js"
import style0 from "./attendance-code-form.vue?vue&type=style&index=0&id=6013ae70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6013ae70",
  null
  
)

export default component.exports